import VueRouter from "vue-router";
import store from "./store";
// Pages
import Login from "./views/Login";
import Email from "./views/password/email";
import Reset from "./views/password/reset";
import Register from "./views/Register";
import Home from "./views/pages/Home";
import FbFanPage from "./views/pages/FbFanPage";
import FbGroup from "./views/pages/FbGroup";
import FbLikeComment from "./views/pages/FbLikeComment";
import FbPost from "./views/pages/FbPost";
import FbFollow from "./views/pages/FbFollow";
import VipLikeClone from "./views/pages/VipLikeClone";
import VipLikeMonth from "./views/pages/VipLikeMonth";
import VipLikeMount from "./views/pages/VipLikeMount";
import VipReactionMonth from "./views/pages/VipReactionMonth";
import VipCommentMonth from "./views/pages/VipCommentMonth";
import FbStream from "./views/pages/FbStream";
import InstaLike from "./views/pages/InstaLike";
import InstaFollow from "./views/pages/InstaFollow";
import InstaComment from "./views/pages/InstaComment";
import Notice from "./views/pages/Notice";
import NotFound from "./views/pages/404";
import CommingSoon from "./views/pages/Commingsoon";
import UserProfile from "./views/pages/UserProfile";
import UserPayment from "./views/pages/UserPayment";
import FbFanPageReview from "./views/pages/FbFanPageReview";
import TikTokLike from "./views/pages/TikTokLike";
import TikTokComment from "./views/pages/TikTokComment";
import TikTokView from "./views/pages/TikTokView";
import FacebookView from "./views/pages/FacebookView";
import YoutubeView from "./views/pages/YoutubeView";
import YoutubeSub from "./views/pages/YoutubeSub";
import TikTokFollow from "./views/pages/TikTokFollow";
import FilterFriends from "./views/pages/extensions/FilterFriends";
import PokeFriends from "./views/pages/extensions/PokeFriends";
import GetCookieAndAccesToken from "./views/pages/extensions/GetCookieAndAccesToken";
import VipLikeInstagramMonth from "./views/pages/VipLikeInstagramMonth";
import VipCommentInstagramMonth from "./views/pages/VipCommentInstagramMonth";
import BuyIP from "./views/pages/BuyIP";
import BotAddUser from "./views/pages/BotAddUser";
import BotListUser from "./views/pages/BotListUser";
import BotActivityLog from "./views/pages/BotActivityLog";
import Support from "./views/pages/Support";
import UserWithdraw from "./views/pages/UserWithdraw";
import Referral from "./views/pages/Referral";
import PriceList from "./views/pages/PriceList";
import FbRipAccount from "./views/pages/FbRipAccount";
import ShareStream from  "./views/pages/ShareStream";
import TicketList from "./views/pages/TicketList";
import TicketReply from "./views/pages/TicketReply";
import TicketCreate from "./views/pages/TicketCreate";
import Telegram from "./views/pages/Telegram";
import PostGroup from "./views/pages/PostGroup";
import SupportSiteTenant from "./views/pages/SupportSiteTenant";
import LikeSubComment from "./views/pages/LikeSubComment";
import YoutubeLike from "./views/pages/YoutubeLike";
import YoutubeView4K from "./views/pages/YoutubeView4K";
import VipLikeTiktok from "./views/pages/VipLikeTiktok";

// Routes
const routes = [
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            auth: false
        }
    },
    {
        path: "/password/email",
        name: "password.email",
        component: Email,
        meta: {
            auth: false
        }
    },
    {
        path: "/password/reset",
        name: "password.reset",
        component: Reset,
        meta: {
            auth: false
        }
    },
    {
        path: "/register",
        name: "register",
        component: Register,
        meta: {
            auth: false
        }
    },
    {
        path: "/home",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    { path: '/', redirect: { name: 'login' }},
    {
        path: "/fb-fan-page",
        name: "fb.fan-page",
        component: FbFanPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-post",
        name: "fb.post",
        component: FbPost,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-follow",
        name: "fb.follow",
        component: FbFollow,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-stream",
        name: "fb.stream",
        component: FbStream,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-review",
        name: "fb.fanpage-review",
        component: FbFanPageReview,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-group",
        name: "fb.group",
        component: FbGroup,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-like-comment",
        name: "fb.like-comment",
        component: FbLikeComment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/insta-like",
        name: "insta.like",
        component: InstaLike,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/insta-follow",
        name: "insta.follow",
        component: InstaFollow,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/insta-comment",
        name: "insta.comment",
        component: InstaComment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tiktok-like",
        name: "tiktok.like",
        component: TikTokLike,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tiktok-comment",
        name: "tiktok.comment",
        component: TikTokComment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tiktok-view",
        name: "tiktok.view",
        component: TikTokView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/facebook-view",
        name: "facebook.view",
        component: FacebookView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fb-rip-account",
        name: "fb.rip-account",
        component: FbRipAccount,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/youtube-view",
        name: "youtube.view",
        component: YoutubeView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/youtube-sub",
        name: "youtube.sub",
        component: YoutubeSub,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tiktok-follow",
        name: "tiktok.follow",
        component: TikTokFollow,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notice",
        name: "notice",
        component: Notice,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: "/user-profile",
        name: "user.profile",
        component: UserProfile,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/user-payment",
        name: "user.payment",
        component: UserPayment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-like-clone",
        name: "vip.like.clone",
        component: VipLikeClone,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-like-month",
        name: "vip.like.month",
        component: VipLikeMonth,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-like-mount",
        name: "vip.like.mount",
        component: VipLikeMount,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-reaction-month",
        name: "vip.reaction.month",
        component: VipReactionMonth,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-comment-month",
        name: "vip.comment.month",
        component: VipCommentMonth,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-like-instagram-month",
        name: "vip.like.instagram.month",
        component: VipLikeInstagramMonth,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-comment-instagram-month",
        name: "vip.comment.instagram.month",
        component: VipCommentInstagramMonth,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/comming-soon",
        name: "commingsoon",
        component: CommingSoon,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: "/extensions/filter-friend",
        name: "extension.filter-fb-friends",
        component: FilterFriends,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/extensions/poke-friend",
        name: "extension.poke-fb-friends",
        component: PokeFriends,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/extensions/get-cookie-and-access-token",
        name: "extension.get-cookie-and-access-token",
        component: GetCookieAndAccesToken,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: "/404",
        name: "not_found",
        component: NotFound,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "*",
        redirect: "/404",
    },
    {
        path: "/buy-ip",
        name: "buy_ip",
        component: BuyIP,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/support",
        name: "support",
        component: Support,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/bot-add-user",
        name: "bot.add_user",
        component: BotAddUser,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/bot-list-user",
        name: "bot.list_user",
        component: BotListUser,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/bot-activity-log",
        name: "bot.activity_log",
        component: BotActivityLog,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/user-widthdraw/:type?",
        name: "user_widthdraw",
        component: UserWithdraw,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/referral",
        name: "referral",
        component: Referral,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/price-list",
        name: "price.list",
        component: PriceList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/share-stream",
        name: "share.stream",
        component: ShareStream,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/ticket/list",
        name: "ticket_list",
        component: TicketList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/ticket/reply/:id", 
        name: "ticket_reply", 
        component: TicketReply, 
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/ticket/create",
        name: "ticket_create",
        component: TicketCreate,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/telegram",
        name: "telegram",
        component: Telegram,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/post-group",
        name: "post.group",
        component: PostGroup,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/support-site",
        name: "support_site",
        component: SupportSiteTenant,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/like-sub-comment",
        name: "like_sub_comment",
        component: LikeSubComment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/youtube-like",
        name: "youtube_like",
        component: YoutubeLike,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/youtube-4k-view",
        name: "youtube_4k_like",
        component: YoutubeView4K,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/vip-like-tiktok",
        name: "vip_like_tiktok",
        component: VipLikeTiktok,
        meta: {
            requiresAuth: true
        }
    },
];
let router = new VueRouter({
    history: true,
    mode: "history",
    routes
});

//Handling unauthorized access cases
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.auth_isLoggedIn) {
            next();
            return;
        }
        next("/login");
        return;
    } else if ((to.name === "login" || to.name === "register") && store.getters.auth_isLoggedIn) {
        next("/home");
        return;
    }
    next();
});
export default router;
